import { createFieldSelectorHook } from 'src/lib/sweetState';
import { WorkspaceStore } from './WorkspaceStore';

const useCurrentWorkspace = createFieldSelectorHook(WorkspaceStore, 'currentWorkspace');

export const useCurrentWorkspaceId = () => {
  const currentWorkspace = useCurrentWorkspace();

  return currentWorkspace?.id;
};
